document.addEventListener("DOMContentLoaded", function() {
  // 固定ボタン
  const follow = document.querySelector(".internship_schedule_floating");
  const gotop = document.querySelector(".gotop");
  const footer = document.querySelector("footer");

  const isAnyItemVisible = () => {
    const items = document.querySelectorAll(".js-floating");
    return Array.from(items).some(item => {
      const rect = item.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    });
  };

  // 予約ボタンが表示されているかどうかを判定
  const followButton = () => {
    follow.style.display = isAnyItemVisible() ? "none" : "block";
  };

  // GoTopボタンの位置調整
  const gotopButton = () => {
    const footerRect = footer.getBoundingClientRect();
    gotop.style.bottom = footerRect.top < window.innerHeight ? (window.innerHeight - footerRect.top) + "px" : "0px";
  };

  const checkVisibility = () => {
    followButton();
    gotopButton();
  };

  window.addEventListener("scroll", checkVisibility);
  window.addEventListener("resize", checkVisibility);
  checkVisibility(); // 初期チェック
});


